
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/hseq",
      function () {
        return require("private-next-pages/about/hseq.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/hseq"])
      });
    }
  